import { put, call, takeLatest, takeEvery, fork, all } from "redux-saga/effects";
import { getConsent, postConsent, getConsentList, getConsentType, getConsentTypeList } from "../api/profileToolsApi";
import * as types from "../constants/actionTypes";
import { log, logAPI } from "../api/andyliticsApi";
import * as Tools from "../helpers/Tools";

export default function* profileToolsSaga() {
    yield takeLatest(types.CONSENT_GET_FLU, handleGetConsent);
    yield takeLatest(types.CONSENT_SET_FLU, handlePostConsent);
    yield takeLatest(types.CONSENT_GET_LIST, handleGetConsentList);
    yield takeLatest(types.CONSENT_TYPE_GET, handleGetConsentType);
    yield takeLatest(types.CONSENT_TYPE_LIST_GET, handleGetConsentTypeList);
}

export function* handleGetConsent(payload) {
    const start = new Date();

    try {
        yield put({ type: types.CONSENT_GET_PENDING });

        const consent = yield call(getConsent, payload.key, payload.token);
        yield put({ type: types.CONSENT_GET_SUCCESS, consent });
        logAPI("MBHWeb.Saga.Profile.GetConsent", start, null);
    }
    catch (error) {
        logAPI("MBHWeb.Saga.Profile.GetConsent.Failure", start, null);
        yield all([
            put({ type: types.CONSENT_GET_FAILURE }),
            put({ type: types.AJAX_CALL_ERROR, error })
        ]);
    }
}


export function* handlePostConsent(payload) {
    const start = new Date();

    try {
        yield put({ type: types.CONSENT_SET_PENDING });
        yield put({ type: types.GET_COMPLETE_FLU_STATUS_PENDING });
        if (payload.key === window.serverData.data.currentFluKey) {
            yield put({ type: types.CONSENT_FLU_PENDING });
        }

        const consent = yield call(postConsent, payload.key, payload.approved, payload.token);
        if (consent.fetchSuccessful === false) {
            yield all([
                put({ type: types.CONSENT_SET_FAILURE }),
                put({ type: types.AJAX_CALL_ERROR, error })
            ]);
            logAPI("MBHWeb.Saga.Profile.PostConsent.Failure", start, null);
        }
        else {
            yield all([
                put({ type: types.REFRESH_TOKEN }),
                put({ type: types.CONSENT_SET_SUCCESS, consent }),
                put({ type: types.GET_COMPLETE_FLU_STATUS_SUCCESS, results: consent })
            ]);
            if (payload.key === window.serverData.data.currentFluKey) {
                yield put({ type: types.CONSENT_FLU_SUCCESS, consent });
            }
            logAPI("MBHWeb.Saga.Profile.PostConsent", start, null);
        }
    }
    catch (error) {
        if (payload.key === window.serverData.data.currentFluKey) {
            yield put({ type: types.CONSENT_FLU_FAILURE });
        }
        yield all([
            put({ type: types.CONSENT_SET_FAILURE }),
            put({ type: types.AJAX_CALL_ERROR, error })
        ]);
        logAPI("MBHWeb.Saga.Profile.PostConsent.Failure", start, null);
    }
}

export function* handleGetConsentList(payload) {
    const start = new Date();

    try {
        yield put({ type: types.CONSENT_GET_PENDING });
        const consent = yield call(getConsentList, payload.token);

        yield all([
            put({ type: types.CONSENT_GET_LIST_SUCCESS, consent })
        ]);

        logAPI("MBHWeb.Saga.Profile.GetConsentList", start, null);
    }
    catch (error) {
        logAPI("MBHWeb.Saga.Profile.GetConsentList.Failure", start, null);
        yield all([
            put({ type: types.CONSENT_GET_LIST_FAILURE }),
            put({ type: types.AJAX_CALL_ERROR, error })
        ]);
    }
}

export function* handleGetConsentType(payload) {
    const start = new Date();

    try {
        yield put({ type: types.CONSENT_TYPE_PENDING });
        const consent = yield call(getConsentType, payload.token, payload.key);

        yield all([
            put({ type: types.CONSENT_TYPE_SUCCESS, consent })
        ]);


        logAPI("MBHWeb.Saga.Profile.GetConsentType", start, null);
    }
    catch (error) {
        logAPI("MBHWeb.Saga.Profile.GetConsentType.Failure", start, null);
        yield all([
            put({ type: types.CONSENT_TYPE_FAILURE }),
            put({ type: types.AJAX_CALL_ERROR, error })
        ]);
    }
}

export function* handleGetConsentTypeList(payload) {
    const start = new Date();

    try {
        yield put({ type: types.CONSENT_TYPE_LIST_PENDING });
        const consent = yield call(getConsentTypeList, payload.token);

        yield all([
            put({ type: types.CONSENT_TYPE_LIST_SUCCESS, consent })
        ]);

        logAPI("MBHWeb.Saga.Profile.GetConsentTypeList", start, null);
    }
    catch (error) {
        logAPI("MBHWeb.Saga.Profile.GetConsentTypeList.Failure", start, null);
        yield all([
            put({ type: types.CONSENT_TYPE_LIST_FAILURE }),
            put({ type: types.AJAX_CALL_ERROR, error })
        ]);
    }
}